import { UseQueryResult } from '@tanstack/react-query';
import { ICycle } from 'models/cycle/cycle.model';

import { IPlanningFilterConfigurationSearchResult } from '../../components/tabs/planningLevelConfiguration/components/planningFilterConfiguration/hooks/usePlanningFilterConfigurationSearch';

export type PlanningTypes = 'collaboration' | 'consensus';

export enum SCREEN_TYPE_TO_ENUM_MAPPING {
	'CONSENSUS' = 'CONSENSUS',
	'COMMERCIAL_COLLABORATION' = 'COMMERCIAL_COLLABORATION',
	'MARKETING_COLLABORATION' = 'MARKETING_COLLABORATION',
	'PLANNING_COLLABORATION' = 'PLANNING_COLLABORATION',
}
export const SCREEN_TYPE_CATEGORY: Record<
	SCREEN_TYPE_TO_ENUM_MAPPING,
	PlanningTypes
> = {
	[SCREEN_TYPE_TO_ENUM_MAPPING.CONSENSUS]: 'consensus',
	[SCREEN_TYPE_TO_ENUM_MAPPING.COMMERCIAL_COLLABORATION]: 'collaboration',
	[SCREEN_TYPE_TO_ENUM_MAPPING.MARKETING_COLLABORATION]: 'collaboration',
	[SCREEN_TYPE_TO_ENUM_MAPPING.PLANNING_COLLABORATION]: 'collaboration',
};

export interface IContextPlanning {
	cycleId: number;
	screenType: SCREEN_TYPE_TO_ENUM_MAPPING;
	companyAreaId: number;
	planningType: PlanningTypes;
	planningFilterConfigurationResult: UseQueryResult<
		IPlanningFilterConfigurationSearchResult,
		any
	>;
	cycle?: ICycle;
	getCanEdit: (cycle?: ICycle) => boolean;
	/** Quando canView e não pode editar: explica bloqueio (permissão ou ciclo). */
	getEditBlockReason: (
		cycle?: ICycle
	) => 'no_edit_permission' | 'deprecated_cycle' | null;
	canView: boolean;
}
